import React, { useState, useRef, useContext} from "react";
import Swal from "sweetalert2";
// import "../../../assests/css/students/Contact.css";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import { AppContext } from "../../context/Appcontext";

const ContactForm = () => {

  const [name,setName]=useState("");
    const [email,setEmail]=useState("");
      const [phone,setPhone]=useState("");
        const [subject,setSubject]=useState("");
          const [message,setMessage]=useState("");
          const { baseUrl} = useContext(AppContext);
  const [captchaValue, setCaptchaValue] = useState(null);

  const recaptchaRef = useRef();

  const handleCaptcha = (value) => {
    setCaptchaValue(value);
  };
   const createContactForm= () => {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("subject", subject);
      formData.append("message", message);
      axios
        .post(`${baseUrl}/student/contact/createContactForm`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          console.log(response.data);
         
        })
        .catch((error) => {
          alert(error?.response?.data?.message || "Something went wrong");
        });
    };

  const handleSubmit = (e) => {
  e.preventDefault();

  // Required fields validation
  if (
    !name ||
    !email ||
    !subject ||
    !message
  ) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please fill all required fields",
    });
    return;
  }

  // Captcha validation
  if (!captchaValue) {
    Swal.fire({
      icon: "error",
      title: "Captcha Required",
      text: "Please verify that you are not a robot.",
    });
    return;
  }
createContactForm();
  // Success SweetAlert
  Swal.fire({
    icon: "success",
    title: "Message Sent!",
    text: "Your message has been sent successfully.",
    confirmButtonColor: "#3085d6",
  });

  // Reset captcha
  recaptchaRef.current.reset();
  setCaptchaValue(null);

  // Reset form
 setName("");
setEmail("");
setPhone("");
setSubject("");
setMessage("");
};

  return (
    <div className="contact-wrapper">
      <div className="contact-box">
        <div className="contact-form">
          <h1>Get In Touch</h1>
          <p>We'd love to hear from you</p>

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Full Name *"
              value={name}
               onChange={(e) => setName(e.target.value)}
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address *"
              value={email}
               onChange={(e) => setEmail(e.target.value)}
            />

            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={phone}
               onChange={(e) => setPhone(e.target.value)}
            />

            <input
              type="text"
              name="subject"
              placeholder="Subject *"
              value={subject}
               onChange={(e) => setSubject(e.target.value)}
            />

            <textarea
              name="message"
              rows="5"
              placeholder="Your Message *"
              value={message}
               onChange={(e) => setMessage(e.target.value)}
        
            ></textarea>
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={handleCaptcha}
            />

            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;